module.exports = __webpack_public_path__ + "img/logo-tc-black.dd3431a6.svg";